<template>
  <span :data-testid="dataTestid">
    <v-tooltip bottom content-class="tooltip-bottom">
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          small
          :disabled="disabled || loading"
          :loading="loading"
          :data-testid="`${dataTestid}__icon`"
          @click="dialogOpen = true"
        >
          <img
            :src="EMAIL_NOTIFICATION.ACTION_ICON.DELETE"
            :alt="EMAIL_NOTIFICATION.ACTION_TOOLTIP.DELETE"
            class="notification-delete-action__img"
          />
        </v-btn>
      </template>
      <span>{{ EMAIL_NOTIFICATION.ACTION_TOOLTIP.DELETE }}</span>
    </v-tooltip>
    <lb-dialog
      :value="dialogOpen"
      :heading="confirmTitle"
      width="440"
      :data-testid="`${dataTestid}__dialog`"
      @input="dialogOpen = $event"
    >
      <template #body>
        <p class="notification-delete-action__message mb-0">{{ confirmBody }}</p>
      </template>
      <template #actions>
        <v-btn text class="secondaryBtn" @click="dialogOpen = false">Cancel</v-btn>
        <v-btn
          class="rejectBtn"
          :loading="loading"
          :data-testid="`${dataTestid}__confirm`"
          @click="onConfirm"
        >
          Delete
        </v-btn>
      </template>
    </lb-dialog>
  </span>
</template>

<script>
import { EMAIL_NOTIFICATION } from '../../../utils/constants';

export default {
  name: 'NotificationDeleteAction',
  props: {
    notification: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    confirmTitle: { type: String, default: 'Delete notification?' },
    confirmBody: { type: String, default: EMAIL_NOTIFICATION.MESSAGES.CONFIRM_DELETE },
    dataTestid: { type: String, default: 'notification-delete-action' },
  },
  data() {
    return {
      dialogOpen: false,
      EMAIL_NOTIFICATION,
    };
  },
  watch: {
    loading(isLoading, wasLoading) {
      if (wasLoading && !isLoading && this.dialogOpen) {
        this.dialogOpen = false;
      }
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.notification);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationDeleteAction.scss';
</style>
